import { User } from '@apis/index'
import GoBack from '@components/back'
import Button from '@components/button'
import PopupToast from '@components/custom-toast'
import Field from '@components/fields'
import Row from '@components/row'
import { Helper, theme } from '@utils'
import authSchema from '@validations/authSchema'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthHeader from '../component/authHeader'
import {
  AuthCard,
  AuthContainer,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
const RegisterPage = () => {
  const navigate = useNavigate()

  const location = useLocation()

  const [loading, setLoading] = useState(false)

  const { phoneNo, countryCode, token } = location.state

  const [isToastOpen, setIsToastOpen] = useState(false)

  const initialValues = {
    phoneNo: phoneNo,
    countryCode: countryCode,
    token: token,
    name: '',
    email: '',
    landmark: '',
    password: '',
    confirmPassword: '',
    agreeToTerms: false, // Default to false
  }

  const [loginDetails, setLoginDetails] = useState({
    username: phoneNo,
    password: '',
  })

  const submitHandler = async (values: any) => {
    setLoading(true)

    const payload = {
      phoneNo,
      countryCode,
      token,
      landmark: values.landmark,
      name: values.name,
      email: values.email,
      password: values.password,
    }
    await User.registerUser(payload)
      .then(() => {
        setLoginDetails({
          username: phoneNo,
          password: values.password,
        })
        setIsToastOpen(true)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const loginUser = async () => {
    setLoading(true)
    await User.login(loginDetails)
      .then((resp) => {
        Helper.saveUser(resp)

        navigate('/books')
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <AuthWrapper>
        <AuthCard>
          <AuthContainer>
            <GoBack visibleForDesktop={false} />
            <AuthHeader content="To get Started Share" tag="Details" />
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={authSchema.registerValidationSchema}
              onSubmit={submitHandler}
            >
              {({ handleSubmit }) => {
                return (
                  <FormWrapper style={{ marginTop: 20 }}>
                    <Form onSubmit={handleSubmit}>
                      <FormContainer>
                        <FormInputsContainer>
                          <Field.Input
                            name="name"
                            label="Name"
                            placeholder="Enter your name"
                          />
                          <Field.Input
                            name="email"
                            label="Email"
                            placeholder="Enter your email"
                          />
                          <Field.Input
                            name="landmark"
                            label="Landmark"
                            placeholder="Enter your Landmark"
                          />
                          <Field.Password
                            name="password"
                            label="Password"
                            placeholder="Enter password"
                          />
                          <Field.Password
                            name="confirmPassword"
                            label="Confirm Password"
                            placeholder="Confirm password"
                          />

                          <Row>
                            <Field.Checkbox
                              name="agreeToTerms"
                              label="I accept the Terms and Condition/Privacy Policy"
                              tagLinks={[
                                {
                                  text: 'Terms and Condition',
                                  onClick: () => navigate('/terms'),
                                  style: `{ color: "${theme.colors.primary}", fontSize: "14px", whiteSpace: "nowrap", fontWeight: "600" }`,
                                },
                                {
                                  text: 'Privacy Policy',
                                  onClick: () => navigate('/privacy'),
                                  style: `{ color: "${theme.colors.primary}", fontSize: "14px", whiteSpace: "nowrap", fontWeight: "600"  }`,
                                },
                              ]}
                            />
                          </Row>
                        </FormInputsContainer>
                        <BottomSection>
                          <Button
                            title="Submit"
                            type="submit"
                            styleButton="width: 100%; height: 40px"
                            loading={loading}
                          />
                        </BottomSection>
                      </FormContainer>
                    </Form>
                  </FormWrapper>
                )
              }}
            </Formik>
          </AuthContainer>
        </AuthCard>
      </AuthWrapper>
      <PopupToast
        isOpen={isToastOpen}
        onClose={() => setIsToastOpen(false)}
        heading="Congratulations!"
        content="Your account has been created successfully."
        buttonText="Go to Login Page"
        onClick={() => loginUser()}
      />
    </>
  )
}

export default RegisterPage
